module.exports = "<itpx-pagetemplate [status]=\"status\" [errorMessage]=\"errorMessage\" [errorTitle]=\"errorTitle\">\n  <page-content>\n    <h1>{{message}}</h1>\n    <ng-content select=\"page-base-content\"></ng-content>\n  </page-content>\n</itpx-pagetemplate>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/partials/pagebase/component.html
// module id = 906
// module chunks = 0